module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_05.d58d3c55.svg";